// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Signup from './components/Signup';
import Dashboard from './components/Dashboard';
import ProfileView from './components/ProfileView';
import ProjectManager from './components/ProjectManager';
import { useAuth } from './contexts/AuthContext';
import About from './components/About';

const App = () => {
  const { currentUser } = useAuth();

  return (
    <Router>
      <Routes>
        {/* If a user is logged in, show the dashboard; otherwise, redirect to login */}
        <Route path="/" element={currentUser ? <Navigate to="/projects" /> : <Navigate to="/login" />} />

        {/* Project Manager route: user must be logged in */}
        <Route
          path="/projects"
          element={currentUser ? <ProjectManager /> : <Navigate to="/login" />}
        />

        {/* Dashboard route: user must be logged in */}
        <Route
          path="/dashboard"
          element={currentUser ? <Dashboard /> : <Navigate to="/login" />}
        />

        {/* Profile route: user must be logged in */}
        <Route
          path="/profile"
          element={currentUser ? <ProfileView /> : <Navigate to="/login" />}
        />

        {/* Auth routes: if user is logged in, redirect to projects */}
        <Route
          path="/login"
          element={!currentUser ? <Login /> : <Navigate to="/projects" />}
        />
        <Route
          path="/signup"
          element={!currentUser ? <Signup /> : <Navigate to="/projects" />}
        />
        <Route path="/about" element={<About />} />

        {/* Catch-all: redirect to login if route not found */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
};

export default App;
